export const sortEmailContent = (attribute1: string, attribute2: string) => {
  const attributeOrder = [
    'subjectLine',
    'preHeader',
    'bodyHeadline',
    'body',
    'disclaimerText',
    'ctaText',
  ];

  const attribute1Index = attributeOrder.indexOf(attribute1);
  const attribute2Index = attributeOrder.indexOf(attribute2);

  return attribute1Index - attribute2Index;
};
